export default class ReadyProduct {
  id: number;
  image: string;
  images: string[];
  name: string;
  price: number;
  details: string;
  dimensions: string;
  createdAt: string;
  updatedAt: string;
  // "available", or "reserved" while another customer is paying for it
  availability: string;

  constructor({
    id,
    image,
    images,
    name,
    price,
    details,
    dimensions,
    created_at,
    updated_at,
    availability,
  }: {
    id: number;
    image: string;
    images: string[];
    name: string;
    price: number;
    details: string;
    dimensions: string;
    created_at: string;
    updated_at: string;
    availability: string;
  }) {
    this.id = id;
    this.image = image;
    this.images = images;
    this.name = name;
    this.price = price;
    this.details = details;
    this.dimensions = dimensions;
    this.createdAt = created_at;
    this.updatedAt = updated_at;
    this.availability = availability;
  }
}